import BaseComponent from './BaseComponent';
import { getRecentSystems } from './helper/recentSystems';

class SystemList extends BaseComponent {
    constructor(el) {
        super(el);
        this.el = el;
        this.maxCount = parseInt(el.dataset.maxCount || '3', 10);
        this.expirationDays = parseInt(el.dataset.expirationDays || '30', 10);
        
        // Initialize search functionality
        this.initializeSearch();
        
        // Initialize recent systems display
        this.initializeRecentSystems();
        
        // Listen for global tracking events to update display
        this.listenForTrackingUpdates();
    }

    initializeSearch() {
        let typingTimer;
        let doneTypingInterval = 1000;
        let search = this.el.querySelector('#search');
        if (!search) {
            return;
        }
        search.addEventListener('keyup', () => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                fetch('?' + search.id + '=' + (search.value ? search.value : '*'))
                    .then((response) => {
                        if (response.ok) {
                            return response.text();
                        }
                        return Promise.reject(response);
                    })
                    .then((html) => {
                        this.el.querySelector('.grid__items').innerHTML = html;
                    })
                    .catch((error) => {
                        console.warn(error);
                    });
            }, doneTypingInterval);
        });
    }

    initializeRecentSystems() {
        // Wait for Cookiebot to be ready
        if (window.Cookiebot && window.Cookiebot.consent) {
            this.handleRecentSystemsDisplay();
        } else {
            window.addEventListener('CookiebotOnConsentReady', () => {
                this.handleRecentSystemsDisplay();
            });
        }
    }

    listenForTrackingUpdates() {
        // Listen for the global tracking event to update display
        window.addEventListener('recentSystemsUpdated', () => {
            // Small delay to ensure cookie is written before reload
            setTimeout(() => {
                this.loadRecentSystems();
            }, 50);
        });
    }

    handleRecentSystemsDisplay() {
        const recentSection = this.el.querySelector('.recent-systems-section');
        if (!recentSection) {
            return;
        }

        // Check if user has given consent
        const hasConsent = window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.preferences;

        if (!hasConsent) {
            // Hide section if no consent
            recentSection.style.display = 'none';
            return;
        }

        // Load and display recent systems
        this.loadRecentSystems();
    }

    loadRecentSystems() {
        const recentSystems = getRecentSystems();
        const recentSection = this.el.querySelector('.recent-systems-section');
        const recentContainer = this.el.querySelector('.recent-systems-container');

        if (!recentSection || !recentContainer) {
            return;
        }

        if (recentSystems.length === 0) {
            recentSection.style.display = 'none';
            return;
        }

        // Show the section
        recentSection.style.display = 'block';

        // Fetch fresh data for recent systems
        const systemIds = recentSystems.slice(0, this.maxCount).join(',');
        
        fetch(`?recentSystemIds=${systemIds}`)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
                return Promise.reject(response);
            })
            .then((html) => {
                recentContainer.innerHTML = html;
            })
            .catch((error) => {
                console.warn('Failed to load recent systems:', error);
                recentSection.style.display = 'none';
            });
    }

}

export default SystemList;
